import * as React from "react";
import { useState, useEffect } from "react";
import Grid from "@mui/material/Grid2";
import ReactImageMagnify from "react-image-magnify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faIndianRupeeSign,
  faShirt,
  faArrowRotateLeft,
  faLock,
  faCartShopping,
} from "@fortawesome/free-solid-svg-icons";
import { motion } from "motion/react";
import { useParams } from "react-router-dom";
import "react-inner-image-zoom/lib/styles.min.css";
import InnerImageZoom from "react-inner-image-zoom";

function ProductDetail() {
  const { id } = useParams();
  const [data, setData] = useState([]);
  const [imgPath, setImgPath] = useState("");
  const [noImgPath, setNoImgPath] = useState("");
  const MotionGrid = motion.create(Grid);

  async function showProductDetail() {
    try {
      let response = await fetch(
        `https://app.thesoyara.com/index.php?r=api/item-details&item_id=${id}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      let result = await response.json();

      if (result?.item_master?.length > 0) {
        setData(result.item_master);
      }
      if (result) {
        setImgPath(result.image_def_path);
        setNoImgPath(result.no_image_path);
      }
    } catch (error) {
      alert("Something went wrong");
    }
  }

  useEffect(() => {
    showProductDetail();
  }, []);

  // const [selectedImage, setSelectedImage] = useState({
  //   small: "https://billing.panachewears.in/uploads//600_766/84737.jpg",
  //   large: "https://billing.panachewears.in/uploads//600_766/84737.jpg",
  // });

  // const thumbnails = [
  //   {
  //     small: "https://billing.panachewears.in/uploads//600_766/84737.jpg",
  //     large: "https://billing.panachewears.in/uploads//600_766/84737.jpg",
  //   },
  //   {
  //     small: "https://billing.panachewears.in/uploads/8/33149.jpeg",
  //     large: "https://billing.panachewears.in/uploads/8/33149.jpeg",
  //   },
  //   {
  //     small: "https://billing.panachewears.in/uploads/1741/70624.jpeg",
  //     large: "https://billing.panachewears.in/uploads/1741/70624.jpeg",
  //   },
  //   {
  //     small: "https://billing.panachewears.in/uploads/1401/64173.jpeg",
  //     large: "https://billing.panachewears.in/uploads/1401/64173.jpeg",
  //   },
  // ];

  const imageVarient = {
    hidden: { scale: 0.6, opacity: 0 },
    visible: { scale: 1, opacity: 1, transition: { duration: 0.6 } },
  };

  const thumbnailVarient = {
    hidden: { y: 50, opacity: 0 },
    visible: { y: 0, opacity: 1, transition: { duration: 0.5, delay: 0.4 } },
  };
  const priceBlockVariants = {
    hidden: { x: 50, opacity: 0 },
    visible: { x: 0, opacity: 1, transition: { duration: 0.5, delay: 0.8 } },
  };

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.4, // Stagger each child animation
        delayChildren: 0.2, // Delay before stagger starts
      },
    },
  };
  const childVariants = {
    hidden: { opacity: 0, scale: 0.6 },
    visible: {
      opacity: 1,
      scale: [0.6, 1.1, 1],
      transition: { duration: 0.8 },
    },
  };

  const features = [
    {
      icon: faArrowRotateLeft,
      title: "3-DAY RETURN",
      description:
        "Wear it. Flaunt it. Return with ease — our eventwear return policy keeps it simple.",
    },
    {
      icon: faLock,
      title: "SECURITY DEPOSIT",
      description:
        "A refundable deposit ensures smooth and secure rentals every time.",
    },
    {
      icon: faShirt,
      title: "CLEAN & HYGIENIC",
      description:
        "Each outfit is dry-cleaned and packaged fresh for your next big moment.",
    },
  ];

  return (
    <div className="product-detail-container">
      <Grid container spacing={8}>
        <Grid size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
          <motion.div
            className="zoom-img-block"
            variants={imageVarient}
            initial="hidden"
            whileInView="visible"
          >
            <InnerImageZoom
              src={
                data?.[0]?.images ? `${imgPath}${data[0].images}` : noImgPath
              }
              zoomSrc={
                data?.[0]?.images ? `${imgPath}${data[0].images}` : noImgPath
              }
              fullscreenOnMobile={true}
              zoomType="hover"
              zoomPreload={true}
              hasSpacer={true}
            />
          </motion.div>
          <motion.div
            className="product-thumbnail-block"
            variants={thumbnailVarient}
            initial="hidden"
            whileInView="visible"
          >
            {data.map((item, index) => (
              <div
                key={item.id}
                className="thumbnail"
                // onClick={() => setSelectedImage(item)}
              >
                <img
                  src={item.images ? `${imgPath}${item.images}` : noImgPath}
                  alt={`Thumbnail ${item.name}`}
                  style={{ height: "100px", cursor: "pointer" }}
                />
              </div>
            ))}
          </motion.div>
        </Grid>
        <Grid size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
          <motion.div
            className="product-detail-price-block"
            variants={priceBlockVariants}
            initial="hidden"
            whileInView="visible"
          >
            <div className="description-block">
            <h2> {data?.[0]?.name}</h2>
            {/* <strong className="product-price">
              <FontAwesomeIcon
                icon={faIndianRupeeSign}
                style={{ fontSize: "17px" }}
              />
              {data?.[0]?.rent_amount}
            </strong> */}

            {/* <Divider /> */}
            <div style={{ paddingTop: "12px" }}>
              <div className="product-cat-block">
                <p>Category</p>
                <p>{data?.[0]?.category_name}</p>
              </div>
              <div className="product-cat-block">
                <p>Type</p>
                <p>{data?.[0]?.type_name}</p>
              </div>
              <div className="product-cat-block">
                <p>Size</p>
                <p>{data?.[0]?.size}</p>
              </div>
            </div>
            </div>
            {/* <button className="add-to-cart-btn" >
              <FontAwesomeIcon icon={faCartShopping} />
              <p> Add to Cart</p>
            </button> */}
            <div className="description-block" style={{marginTop:'20px'}}>
              <p className="des-text">Description</p>
              <p className="product-sub-detail">{data?.[0]?.details}</p>
            </div>
          </motion.div>
        </Grid>
        {/* <Grid size={{ lg: 3, md: 3, sm: 12, xs: 12 }}>
          <motion.div
            variants={containerVariants}
            initial="hidden"
            whileInView="visible"
          >
            <motion.div variants={childVariants}>
              <Card className="terms-condition-container">
                <CardContent className="terms-condition-content">
                  <div className="icon-block">
                    <FontAwesomeIcon
                      className="main-icon"
                      icon={faArrowRotateLeft}
                    />
                    <FontAwesomeIcon
                      className="shadow-icon"
                      icon={faArrowRotateLeft}
                    />
                  </div>
                  <div className="condition-block">
                    <h5 className="terms-condition-title">3 Days Return</h5>
                    <p className="detail-text">
                      Pick up, wear, and return - that's our hassle-free event
                      outfit policy.
                    </p>
                  </div>
                </CardContent>
              </Card>
            </motion.div>
            <motion.div variants={childVariants}>
              <Card className="terms-condition-container">
                <CardContent className="terms-condition-content">
                  <div className="icon-block">
                    <FontAwesomeIcon className="main-icon" icon={faLock} />
                    <FontAwesomeIcon className="shadow-icon" icon={faLock} />
                  </div>
                  <div className="condition-block">
                    <h5 className="terms-condition-title">Security Deposit</h5>
                    <p className="detail-text">
                      A security deposit is applicable for rental purposes.
                    </p>
                  </div>
                </CardContent>
              </Card>
            </motion.div>
            <motion.div variants={childVariants}>
              <Card className="terms-condition-container">
                <CardContent className="terms-condition-content">
                  <div className="icon-block">
                    <FontAwesomeIcon className="main-icon" icon={faShirt} />
                    <FontAwesomeIcon className="shadow-icon" icon={faShirt} />
                  </div>
                  <div className="condition-block">
                    <h5 className="terms-condition-title">
                      Cleanliness and Hygiene
                    </h5>
                    <p className="detail-text">
                      Dresses are dry-cleaned and packaged before pickup.
                    </p>
                  </div>
                </CardContent>
              </Card>
            </motion.div>
          </motion.div>
        </Grid> */}
      </Grid>
      {/* <Grid container spacing={8}>
        <Grid size={{ lg: 12, md: 12, sm: 12, xs: 12 }}> */}
      <MotionGrid
        className="feature-wrapper"
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        container
        spacing={6}
      >
        {features.map((feature, index) => (
          <MotionGrid
            size={{ lg: 4, md: 4, sm: 12, xs: 12 }}
            key={index}
            variants={childVariants}
            className="feature-card"
          >
            <div className="icon-block">
              <FontAwesomeIcon className="main-icon" icon={feature.icon} />
              <FontAwesomeIcon className="shadow-icon" icon={feature.icon} />
            </div>
            <div className="feature-text">
              <h4 className="feature-title">{feature.title}</h4>
              <p className="feature-description">{feature.description}</p>
            </div>
          </MotionGrid>
        ))}
      </MotionGrid>
      {/* </Grid>
      </Grid> */}
    </div>
  );
}
export default ProductDetail;
